import { render, staticRenderFns } from "./EditInstitutionPage.vue?vue&type=template&id=1935460c&scoped=true&"
import script from "./EditInstitutionPage.vue?vue&type=script&lang=js&"
export * from "./EditInstitutionPage.vue?vue&type=script&lang=js&"
import style0 from "./EditInstitutionPage.vue?vue&type=style&index=0&id=1935460c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935460c",
  null
  
)

export default component.exports